const className = (block, element, modifier, selector) => ([
	selector ? '.' : '',
	'js-',
	block,
	element ? `__${element}` : '',
	modifier ? `--${modifier}` : '',
].join(''));

module.exports = {

	states: {
		active: 'is-active',
		fixed: 'is-fixed',
		hidden: 'is-hidden',
		loading: 'is-loading',
		busy: 'is-busy',
		initialised: 'is-initialised',
		open: 'is-open',
		scrollable: 'is-scrollable',
	},

	block(name){
		if( !name ){
			throw new Error('Empty block name.');
		}

		return {

			event(event){
				return `${name}:${event}`;
			},

			class: (element, modifier) => className(name, element, modifier),

			selector: (element, modifier) => className(name, element, modifier, true),

		};
	},

};



// WEBPACK FOOTER //
// ./src/js/modules/bem.js